<template>
  <multi-select-plain
    ref="select"
    v-if="type === 'plain'"
    v-bind="$props"
  >
    <slot
      slot="button"
      name="button"
    ></slot>
    <slot
      slot="header"
      name="header"
    />
    <slot
      slot="footer"
      name="footer"
    />
    <slot
      slot="applyButton"
      name="apply-button"
    />
    <slot
      slot="clearButton"
      name="clear-button"
    />
    <template
      slot="option"
      slot-scope="props"
    >
      <slot
        v-if="$scopedSlots.option"
        name="option"
        :item="props.item"
      />
      <slot
        v-else
        name="option"
      >
        {{ props.item[nameKey] }}
      </slot>
    </template>
  </multi-select-plain>
  <multi-select-tree
    ref="select"
    v-else-if="type === 'tree'"
    v-bind="$props"
  >
    <slot
      slot="button"
      name="button"
    ></slot>
    <slot
      slot="header"
      name="header"
    />
    <slot
      slot="footer"
      name="footer"
    />
    <slot
      slot="applyButton"
      name="apply-button"
    />
    <slot
      slot="clearButton"
      name="clear-button"
    />
    <template
      slot="option"
      slot-scope="props"
    >
      <slot
        v-if="$scopedSlots.option"
        name="option"
        :item="props.item"
      />
      <slot
        v-else
        name="option"
      >
        {{ props.item[nameKey] }}
      </slot>
    </template>
  </multi-select-tree>
</template>

<script>
  import MultiSelectPlain from './multi-select-plain';
  import MultiSelectTree from './multi-select-tree';
  import { noop } from '../../utils/util';
  // import '../../../i18n/select';
  // import { t } from '../../locale';

  export default {
    name: 'ZmMultiSelect',
    components: {
      MultiSelectPlain,
      MultiSelectTree
    },
    props: {
      type: {
        type: String,
        default: 'plain' // plain / tree
      },
      value: {
        type: Array,
        default() {
          return [];
        }
      },
      options: {
        type: Array,
        default() {
          return [];
        }
      },
      disabled: Boolean,
      valueKey: {
        type: String,
        default: 'id'
      },
      nameKey: {
        type: String,
        default: 'label'
      },
      childKey: {
        type: String,
        default: 'children'
      },
      disabledKey: {
        type: String,
        default: 'disabled'
      },
      showAllLevels: {
        type: Boolean,
        default: true
      },
      convertAllToEmpty: Boolean,
      hasMore: Boolean,
      remoteMethod: {
        type: Function
      },
      clearVisible: {
        type: Boolean,
        default: true
      },
      searchVisible: {
        type: Boolean,
        default: true
      },
      buttonVisible: {
        type: Boolean,
        default: true
      },
      filterAllVisible: {
        type: Boolean,
        default: true
      },
      placeholder: {
        type: String,
        default: 'Please select'
      },
      allSelectedLabel: {
        type: String,
        default: ''
      },
      searchPlaceholder: {
        type: String,
        default: 'Search filters'
      },
      filterAllLabel: {
        type: String,
        default: 'Filter (All)'
      },
      confirmLabel: {
        type: String,
        default: 'Apply'
      },
      clearLabel: {
        type: String,
        default: 'Clear'
      },
      collapseTags: Boolean,
      maxLine: {
        type: Number,
        default: 1
      },
      poperWidth: {
        type: Number,
        default: 0
      },
      beforeChange: {
        type: Function,
        default: undefined
      },
      defaultExpandAll: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
      };
    },
    mounted() {
      this.makeProxy();
    },
    watch: {
      filterable() {
        this.$nextTick(this.makeProxy);
      }
    },
    methods: {
      makeProxy() {
        this.proxyEvents();
        this.proxyMethods();
        this.proxyData();
        this.proxyRefs();
      },
      proxyEvents() {
        const events = ['input', 'data-change', 'visible-change'];
        const vm = this.$refs.select;
        events.forEach((event) => {
          vm.$on(event, (...args) => {
            this.$emit.apply(this, [event, ...args]);
          });
        });
      },
      proxyMethods() {
        const methods = [];
        methods.forEach((method) => {
          const vm = this.$refs.select;
          if (vm[method]) {
            this[method] = vm[method].bind(vm);
          } else {
            this[method] = noop;
          }
        });
      },
      proxyData() {
        const vm = this.$refs.select;
        Object.keys(this._data).forEach((key) => {
          vm.$watch(key, (newVal) => {
            this[key] = newVal;
          }, { immediate: true });
        });

        Object.keys(this._data).forEach((key) => {
          this.$watch(key, (newVal) => {
            vm[key] = newVal;
          });
        });
      },
      proxyRefs() {
        const vm = this.$refs.select;
        const refs = ['dropdown'];
        refs.forEach((ref) => {
          this.$refs[ref] = vm.$refs[ref];
        });
      }
    }
  };
</script>

